import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import bsc from '../../assets/bsc.png';
import eth from '../../assets/eth.png';
import sol from '../../assets/sol.png';
import arbitrum from '../../assets/arbitrum.svg';
import base from '../../assets/base.svg';
import polygon from '../../assets/polygon.svg';
import avax from '../../assets/avax.webp';
import pepu from '../../assets/pepu.webp';
import robin from '../../assets/robin.svg';
import { PiTelegramLogoLight } from "react-icons/pi";
import { RiTwitterXFill } from "react-icons/ri";
import ProjectDisplay from '../projectdisplay/ProjectDisplay';
import Trending from '../trendingbar/Trending';
import { IoIosSearch } from "react-icons/io";
import { CiMenuBurger } from "react-icons/ci";
import cslogo from '../../assets/logo_cs.png';
import { MdOutlineInfo } from "react-icons/md";
import { MdVerified } from "react-icons/md";
import { VscUnverified } from "react-icons/vsc";
import { FaPlus } from "react-icons/fa6";
import { TbArrowBackUp } from "react-icons/tb";
import AddressDisplay from '../addressdisplay/AddressDisplay';
import Unlisted from '../unlisted/Unlisted';
import UnlistedLogo from '../../assets/unlisted-logo.png';

const Info = MdOutlineInfo as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TG = PiTelegramLogoLight as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const X = RiTwitterXFill as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Search = IoIosSearch as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Ham = CiMenuBurger as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Verified = MdVerified  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Unverified = VscUnverified as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Plus = FaPlus as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Back = TbArrowBackUp as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


type ListingType = 'verified' | 'unverified' | null;

const embedConfig: Record<Exclude<ListingType, null>, { id: string; token: string }> = {
  verified: {
    id: 'tripetto-kkiuf0',
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiSDVEZXl1LzY5OUlWMkhiVVJTRWRxalczNE9CM24wU1N5d1h1bGdoMnQxQT0iLCJkZWZpbml0aW9uIjoiYmdTcE9NUXczY0h5Ukt6cWVWK1F1aUpFOS83cHlYSEFsQyt5bFB3OFpJYz0iLCJ0eXBlIjoiY29sbGVjdCJ9.a-SLKTBo6vnZmQavMy8jLHc7xU3g6Sk1gDHtz5bjPVY'
  },
  unverified: {
    id: 'tripetto-9auy0o',
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiSDVEZXl1LzY5OUlWMkhiVVJTRWRxalczNE9CM24wU1N5d1h1bGdoMnQxQT0iLCJkZWZpbml0aW9uIjoiWis2MnlsekVJN0JqdDZLaHVHZFhjSWZxOVhTK0NIUWdjNEkyaEgvTUp6QT0iLCJ0eXBlIjoiY29sbGVjdCJ9.JnlgygMFizIFWVkT6_jv8bcyFRXPGpqeG7gLcuNMO0Q'
  }
};

const Header: React.FC = () => {
  const [keyword, setKeyword] = useState('');
  const [data, setData] = useState<any[]>([]);
  const [results, setResults] = useState<any[]>([]);
  const [dbResults, setDbResults] = useState<any[]>([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isListActive, setIsListActive] = useState(false);
  const [selectedListing, setSelectedListing] = useState<ListingType>(null);
  const overlayRef = useRef<HTMLDivElement>(null);
  const listOverlayRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          'https://coinsult.dev/wp-json/wp/v2/tokens?per_page=4&_fields=meta,title,date'
        );
        if (!res.ok) throw new Error('Network response was not ok');
        const tokens = await res.json();
        setData(tokens);
      } catch (err: any) {
        console.error(err.message);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (keyword.trim().length >= 2) {
        fetch(`https://api.dexview.com/pair/search?keyword=${encodeURIComponent(keyword)}`, {
          headers: {
            "accept": "application/json, text/plain, */*",
            "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
            "if-none-match": "W/\"2244-8e+vWX7JgZT7/hBnItO2lL1ZTqo\"",
            "priority": "u=1, i",
            "sec-ch-ua": "\"Not(A:Brand\";v=\"99\", \"Google Chrome\";v=\"133\", \"Chromium\";v=\"133\"",
            "sec-ch-ua-mobile": "?0",
            "sec-ch-ua-platform": "\"Windows\"",
            "sec-fetch-dest": "empty",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-site",
            "secret": "5ff3a258-2700-11ed-a261-0242ac120002"
          },
          method: 'GET',
          mode: 'cors',
          credentials: 'omit'
        })
          .then((res) => res.json())
          .then((json) => {
            if (json?.data) setResults(json.data.slice(0, 5));
          })
          .catch((err) => console.error(err));
      } else {
        setResults([]);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [keyword]);

  useEffect(() => {
    const timerTwo = setTimeout(() => {
      if (keyword.trim().length >= 2) {
        fetch(`https://coinsult.dev/wp-json/wp/v2/tokens?search=${encodeURIComponent(keyword)}&_fields=title,meta,id`, {
        })
          .then((res) => res.json())
          .then((json) => {
            if (json) setDbResults(json.slice(0, 5));
              console.log(json.slice(0, 5));
          })
          .catch((err) => console.error(err));
      } else {
        setDbResults([]);
      }
    }, 500);

    return () => clearTimeout(timerTwo);
  }, [keyword]);

  // Clean up and initialize Tripetto form
  useEffect(() => {
    // Function to safely remove a child from parent
    const safeRemoveChild = (parent: ParentNode, child: ChildNode | null) => {
      if (child && parent.contains(child)) {
        parent.removeChild(child);
      }
    };

    // Clean up existing form elements
    const formIds = ['tripetto-kkiuf0', 'tripetto-9auy0o'];
    formIds.forEach(id => {
      const existingForm = document.getElementById(id);
      if (existingForm) {
        // Clear the form container
        existingForm.innerHTML = '';
      }
    });

    // Clean up previous script if it exists
    if (scriptRef.current) {
      safeRemoveChild(document.body, scriptRef.current);
      scriptRef.current = null;
    }

    // Initialize new form if we have a selectedListing
    if (selectedListing) {
      const formId = embedConfig[selectedListing].id;
      
      // Create and add the script with a delay to ensure DOM is ready
      setTimeout(() => {
        const init = document.createElement('script');
        init.innerHTML = `
          try {
            if (typeof TripettoStudio !== 'undefined' && typeof TripettoAutoscroll !== 'undefined') {
              TripettoStudio.form({ 
                runner: TripettoAutoscroll, 
                token: "${embedConfig[selectedListing].token}", 
                element: "${formId}" 
              });
            }
          } catch(e) {
            console.error("Error initializing Tripetto form:", e);
          }
        `;
        document.body.appendChild(init);
        scriptRef.current = init;
      }, 100);
    }

    // Clean up on component unmount or when selectedListing changes
    return () => {
      if (scriptRef.current && document.body.contains(scriptRef.current)) {
        document.body.removeChild(scriptRef.current);
      }
    };
  }, [selectedListing, isPaid]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
        setIsFocused(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsSearchActive(false);
        setIsListActive(false);
      }
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    if (isSearchActive && inputRef.current) {
      setTimeout(() => inputRef.current!.focus(), 0);
    }
  }, [isSearchActive]);

  // Handle closing the listing popup
  const handleCloseListPopup = () => {
    // Clean up any forms first
    const formIds = ['tripetto-kkiuf0', 'tripetto-9auy0o'];
    formIds.forEach(id => {
      const container = document.getElementById(id);
      if (container) {
        container.innerHTML = '';
      }
    });
    
    // Remove any script elements
    if (scriptRef.current && document.body.contains(scriptRef.current)) {
      document.body.removeChild(scriptRef.current);
      scriptRef.current = null;
    }
    
    // Reset states
    setIsListActive(false);
    setSelectedListing(null);
  };

  // Handle going back to listing selection
  const handleBackToSelection = () => {
    // First clean up the form container
    const formId = selectedListing ? embedConfig[selectedListing].id : null;
    if (formId) {
      const formContainer = document.getElementById(formId);
      if (formContainer) {
        formContainer.innerHTML = '';
      }
    }
    
    // Then reset the selected listing state
    setSelectedListing(null);
    setIsPaid(false);
  };

  const relativeTime = (dateString: string) => {
    const diffSeconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000);
    if (diffSeconds < 60) return `${diffSeconds} second${diffSeconds !== 1 ? 's' : ''} ago`;
    const diffMinutes = Math.floor(diffSeconds / 60);
    if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 365) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    const diffYears = Math.floor(diffDays / 365);
    return `${diffYears} year${diffYears !== 1 ? 's' : ''} ago`;
  };

  const getChainName = (chainId: number | string) => {
    switch (Number(chainId)) {
      case 1: return 'eth';
      case 56: return 'bsc';
      case 501424: return 'sol';
      case 8453: return 'base';
      case 42161: return 'arbitrum';
      case 43114: return 'avax';
      case 137: return 'polygon';
      case 4663: return 'robin';
      default: return chainId;
    }
  };

  const renderPriceChange = (change: string | number) => {
    const value = parseFloat(change as string);
    const formattedValue = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const changeClass = value >= 0 ? 'green' : 'red';
    return <div className={`redgreen ${changeClass}`}>{formattedValue}%</div>;
  };

  const formatVolume = (volume: number): string => {
    if (!volume && volume !== 0) return '-';
    if (Math.abs(volume) >= 1_000_000_000) return (volume / 1_000_000_000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'B';
    if (Math.abs(volume) >= 1_000_000) return (volume / 1_000_000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'M';
    if (Math.abs(volume) >= 1_000) return (volume / 1_000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'K';
    return volume.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const sideBarOpen = () => {
    const sidebar = document.querySelector<HTMLElement>('.sidebar-left');
    if (sidebar) sidebar.style.display = 'block';
  };

  return (
    <>
      {/* Search Popup Overlay */}
      <div
        ref={overlayRef}
        className={`search-overlay ${isSearchActive ? 'overlay-active' : ''}`}
        onClick={e => e.target === overlayRef.current && setIsSearchActive(false)}
      >
        <div className="search-overlay-box">
          <div className="search-field">
            <input
              type="text"
              placeholder="Search token / ca..."
              value={keyword}
              className="search-box"
              onChange={e => setKeyword(e.target.value)}
              onFocus={() => setIsFocused(true)}
              ref={inputRef}
            />
            {isFocused && (results.length > 0 || dbResults.length > 0) && (
              <div className="search-results">
                {dbResults.length > 0 && (
                  <div className="divider-search-results">
                    Listed Projects
                  </div>
                )}
                {dbResults.map(item => (
                  <a
                    key={item.id}
                    className="search-item"
                    href={`/${item.meta.chain}/${item.meta.contract_address}`}
                  >
                    <div className="logo-chain">
                      {item.meta.logo_file && <img src={item.meta.logo_file || UnlistedLogo} className='logo-token-file' alt="Token logo" />}
                      
                      <img className='logo-chain-file' src={
                        item.meta.chain === 'bsc' ? bsc :
                        item.meta.chain === 'eth' ? eth :
                        item.meta.chain === 'sol' ? sol :
                        item.meta.chain === 'solana' ? sol :
                        item.meta.chain === 'base' ? base :
                        item.meta.chain === 'arbitrum' ? arbitrum :
                        item.meta.chain === 'avax' ? avax :
                        item.meta.chain === 'polygon' ? polygon :
                        item.meta.chain === 'pepu' ? pepu :
                        item.meta.chain === 'robin' ? robin :
                        ''
                      } alt="Chain logo" />
                    </div>
                    <div className="information">
                      <div className="info-row">
                        <p>{item.title.rendered} <span className="symbolinforow">{item.meta.symbol}</span></p>
                      </div>
                      <div className="info-row">
                        <div className='cainforow'>{`${item.meta.contract_address.slice(0, 7)}...${item.meta.contract_address.slice(-6)}`}</div>
                      </div>
                    </div>
                  </a>
                ))}
                {results.length > 0 && (
                  <div className="divider-search-results">
                    Unlisted On-chain Projects
                  </div>
                )}
                {results.map(item => (
                  <a
                    key={item._id}
                    className="search-item"
                    href={`/${getChainName(item.chainId)}/${item.baseToken}`}
                  >
                    <div className="logo-chain">
                      <img src={UnlistedLogo} className='logo-token-file' alt="Token logo" />
                      <img className='logo-chain-file' src={
                        item.chainId === '56' ? bsc :
                        item.chainId === '1' ? eth :
                        item.chainId === '501424' ? sol :
                        item.chainId === '8453' ? base :
                        item.chainId === '42161' ? arbitrum :
                        item.chainId === '137' ? polygon :
                        item.chainId === '43114' ? avax :
                        item.chainId === '4663' ? robin :
                        ''
                      } alt="Chain logo" />
                    </div>
                    <div className="information">
                      <div className="info-row">
                        <p>{item.baseTokenName} <span className="symbolinforow">{item.baseTokenSymbol}</span></p>
                      </div>
                      <div className="info-row">
                        <div className='cainforow'>{`${item.baseToken.slice(0, 7)}...${item.baseToken.slice(-6)}`}</div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            )}
            <div className="recently-listed-header">
              <div className='recent-list'>Recently listed</div>
              {data.map((token, index) => {
                const { meta, date } = token;
                const tokenTitle = token.title?.rendered;
                return (
                  <ProjectDisplay
                    key={index}
                    verified={meta.verified}
                    image={meta.logo_file}
                    chain={meta.chain}
                    title={tokenTitle}
                    symbol={meta.symbol}
                    countdown={relativeTime(date)}
                    address={meta.contract_address}
                    banner={meta.banner}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <header>
        <div className="header-left">
          <div className='hamburgermenu' onClick={sideBarOpen}><Ham /></div>
          <div className='search-popup' onClick={() => setIsSearchActive(true)}><Search /> Search...</div>
          <a className="socialheader" href='https://t.me/coinsult' target='_blank'><TG /> 5.22k</a>
          <a className="socialheader" href='https://x.com/coinsultaudits' target='_blank'><X /> 43.2k</a>
        </div>

        <div className="header-right">
          <a className="header-button noaccent" href='/advertise'>Advertise</a>
          <a className="header-button noaccent" href='https://t.me/coinsult_tg' target='_blank'>Request Service</a>
          <a className="header-button" href='/list'>List Project <Plus /></a>
        </div>
      </header>
      <Trending />
    </>
  );
};

export default Header;